import {
  Action,
  ActionType,
  IUpdateVenuesResponse,
} from "models/vaccine/updateVenues";
import createReducer from "../../../createReducer";

export interface UpdateVenuesReducerType {
  loading: boolean;
  error?: string;
  updateVenuesResponse?: IUpdateVenuesResponse;
}

const defaultState: UpdateVenuesReducerType = {
  loading: false,
  error: undefined,
  updateVenuesResponse: undefined,
};

export const updateVenuesReducer = createReducer<UpdateVenuesReducerType>(
  defaultState,
  {
    [ActionType.VACCINE_UPDATE_VENUES](state: UpdateVenuesReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.VACCINE_UPDATE_VENUES_ERROR](
      state: UpdateVenuesReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.VACCINE_UPDATE_VENUES_SUCCESS](
      state: UpdateVenuesReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        updateVenuesResponse: action.payload,
      };
    },

    [ActionType.VACCINE_UPDATE_VENUES_RESET](state: UpdateVenuesReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        updateVenuesResponse: undefined,
      };
    },
  }
);
